import styled, { css, keyframes } from 'styled-components';

import { ClassNameInjector } from "./ClassNameInjector";

const fadeInAnimation = /*#__PURE__*/keyframes(["from{opacity:0;}to{opacity:1;}"]);








const fadeOutAnimation = /*#__PURE__*/keyframes(["from{opacity:1;}to{opacity:0;}"]);








export const FadeInOutAnimation = /*#__PURE__*/styled(ClassNameInjector).withConfig({ displayName: "FadeInOutstyles__FadeInOutAnimation", componentId: "sc-1oa8j62-0" })(


({ active, animationDurationInMs }) => {
  if (active) {
    return css(["animation-name:", ";animation-timing-function:", ";animation-duration:", "ms;"],
    fadeInAnimation,
    'ease-in',
    animationDurationInMs);

  } else {
    return css(["animation-name:", ";animation-timing-function:", ";animation-duration:", "ms;"],
    fadeOutAnimation,
    'ease-out',
    animationDurationInMs);

  }
});